<template>
    <section id="login" class="container">
        <h1>{{ $t('login.titulo') }}</h1>

        <b-form @submit.prevent="submit" class="login">
            <div class="row">
                <div class="col-md-12">
                    <!-- E-mail -->
                    <b-form-group :label="$t('login.email.label')" label-for="email">
                        <b-form-input
                            id="email"
                            v-model="form.email"
                            type="email"
                            required
                            :placeholder="$t('login.email.placeholder')"
                        ></b-form-input>
                    </b-form-group>

                    <!-- Senha -->
                    <b-form-group :label="$t('login.senha.label')" label-for="password">
                        <b-form-input
                            id="password"
                            v-model="form.password"
                            type="password"
                            required
                            :placeholder="$t('login.senha.placeholder')"
                        ></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <hr/>

            <div class="row">
                <div class="col-md-12">
                    <div class="botoes">
                        <router-link :to="{ name: 'create', query: { from: $route.query.from }}" class="btn btn-outline-primary">
                            {{ $t('login.botao.cadastrar') }}
                        </router-link>
                        <button type="submit" class="btn btn-success">{{ $t('login.botao.entrar') }}</button>
                    </div>
                    <!-- <router-link :to="{ name: 'recovery' }" class="btn btn-link">
                        {{ $t('login.botao.recuperar') }}
                    </router-link> -->
                </div>--
            </div>
        </b-form>
    </section>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    data: () => ({
        form: {
            email: '',
            password: ''
            // email: 'felipe.aufe@gmail.com',
            // password: '123456'
        }
    }),
    methods: {
        ...mapActions('auth', ['ActionDoLogin']),
        async submit () {
            try {
                await this.ActionDoLogin(this.form)
                setTimeout(() => {
                    this.$router.push(this.$route.query.from || '/')
                }, 2000)
                // this.$router.go({ name: 'home' })
            } catch (err) {
                console.error(err)

                this.$notify({
                    duration: 10000,
                    group: 'foo',
                    type: 'error',
                    title: 'Ops!',
                    text: err.body ? err.body.message : 'Não foi possível fazer o login!'
                })
            }
        }
    }
}

</script>

<style lang="sass" scoped>
    #login
        display: flex
        flex-direction: column
        padding: 10px
        margin-top: 120px
        max-width: 400px
        h1
            margin: 0 auto
        .btn
            width: calc(50% - 10px)
            margin: 0 auto 5px
        .botoes
            display: flex
</style>
